import React from "react";
import PropTypes from "prop-types";
import { Configure } from "react-instantsearch";
import { DEFAULT_BROWSE_PARAM, UNFILTERED_FACETS_PARAM } from "./withUnfilteredDefaultFacets";

// Hides bare sources (indexed `show_in_default_index:false`) from the default browse view while
// keeping them searchable. withUnfilteredDefaultFacets, which must wrap the search client, decides
// per request whether it is default browse. baseFilter is an objectID OR-list, so it replaces the
// clause rather than being ANDed onto it. unfilteredFacets: the filter panel is open.
export default function DefaultIndexConfigure({ baseFilter, unfilteredFacets = false }) {
  const markers = { [DEFAULT_BROWSE_PARAM]: true, ...(unfilteredFacets && { [UNFILTERED_FACETS_PARAM]: true }) };

  return <Configure filters={baseFilter || ""} {...markers} />;
}

DefaultIndexConfigure.propTypes = {
  baseFilter: PropTypes.string,
  unfilteredFacets: PropTypes.bool,
};
